// extracted by mini-css-extract-plugin
export var fadePop = "LatestDynamicContent-module--fade-pop--6f11b";
export var growHeightIn = "LatestDynamicContent-module--grow-height-in--c7c52";
export var row = "LatestDynamicContent-module--row--11d17";